'use strict';

(function () {
  'use strict';
  /**
   * A service to wrap ga().
   */

  angular.module('msCore').service('msGa', gaWrapperSvc);

  gaWrapperSvc.$inject = ['$window'];

  function gaWrapperSvc($window) {
    if (_.isFunction($window.ga)) {
      return $window.ga;
    } else {
      return _.noop;
    }
  }
})();